import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-invoiceRule`;

const getInvoiceRules = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/invoice-period-rules`);
};

const postInvoiceRules = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/invoice-period-rules`, data);
};

const putInvoiceRules = (merchantId, id, data) => {
	return Client.put(
		`${baseUrl}/${merchantId}/invoice-period-rules/${id}`,
		data
	);
};

export default {
	getInvoiceRules,
	postInvoiceRules,
	putInvoiceRules,
};
